import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { AssistantChatsContent } from '@/pageContents/kiEinstellungen/AssistantChatsContent';
import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Permission } from '@/models/user';

const AssistantChats: PageWithLayout = () => (
    <>
        <Helmet>
            <title>Chatverläufe | Starjack Backoffice</title>
        </Helmet>
        <Box sx={{ p: 3 }}>
            <AssistantChatsContent />
        </Box>
    </>
);

AssistantChats.isProtected = true;
AssistantChats.getLayout = (Comp) => <SidebarLayout>{Comp}</SidebarLayout>;
AssistantChats.permissions = [Permission.ADMIN];

export default AssistantChats;
